import { BasicSearch, MobileSearch } from '@/components/Search';
import Media from 'react-media';
import { BasicSearchWrapper } from './styled';
import { useTheme } from '@simplywallst/ui-core';
import type { CustomPeer } from '@/pages/CompanyReport/components/Valuation/query';
import { useEffect, useState } from 'react';

type Props = {
  index: number;
  peer: CustomPeer;
  selectingPeers: CustomPeer[];
  uniqueSymbol: string;
  isError: boolean;
  onError: (index: number, isError: boolean) => void;
  onSelectPeer: (index: number, newPeer: CustomPeer) => void;
  onResetPeer: (index: number) => void;
};

export const PeerSearch = ({
  index,
  peer,
  selectingPeers,
  isError,
  uniqueSymbol,
  onError,
  onSelectPeer,
  onResetPeer,
}: Props) => {
  const theme = useTheme();
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (!isError) setErrorMsg('');
  }, [isError]);

  const setValidCustomPeer = (newPeer: CustomPeer) => {
    const peerFound = selectingPeers.find(
      (currentPeer) => currentPeer.id === newPeer.id
    );
    if (peerFound) {
      setErrorMsg('Duplicated symbol. Select a different company.');
      onError(index, true);
      return newPeer;
    }
    if (newPeer.id === uniqueSymbol) {
      setErrorMsg('Symbol already selected.');
      onError(index, true);
      return newPeer;
    }
    setErrorMsg('');
    onError(index, false);
    return newPeer;
  };
  const handleSelectPeer = (index: number, newPeer: CustomPeer) => {
    const validPeer = setValidCustomPeer(newPeer);
    onSelectPeer(index, validPeer);
  };
  const handleResetPeer = (index: number, value: string) => {
    if (value === '') {
      setErrorMsg('All peers required to continue. Please pick 4 companies.');
      onResetPeer(index);
      onError(index, true);
    }
  };

  return (
    <BasicSearchWrapper addMargin={errorMsg !== ''} key={peer.id}>
      <Media query={{ maxWidth: theme.mdMaxRaw }}>
        {(match) => {
          if (match) {
            return (
              <MobileSearch
                name={peer.name}
                value={peer.name}
                theme="light"
                error={errorMsg}
                onReset={() => handleResetPeer(index, '')}
                onClick={(newPeer) => {
                  handleSelectPeer(index, newPeer);
                }}
              />
            );
          }
          return (
            <BasicSearch
              name={peer.name}
              value={peer.name}
              theme="light"
              onReset={() => handleResetPeer(index, '')}
              //TODO: @riccarb refactor onClick to return company name and remove onSelectCompany
              onSelectCompany={(newPeer) => {
                handleSelectPeer(index, newPeer);
              }}
              error={errorMsg}
              onBlur={(value) => handleResetPeer(index, value)}
            />
          );
        }}
      </Media>
    </BasicSearchWrapper>
  );
};
